import { FC } from "react";
import styles from "../Defect.module.scss";
import classNames from "classnames";

import {
  DEFECT_STATUS_AGREED,
  DEFECT_STATUS_CLOSED,
  DEFECT_STATUS_REMOVED,
  DEFECT_STATUS_REJECTED,
  UNLOADING_MK_SENT,
  UNLOADING_MK_ERROR,
} from "../constants";

interface DefectCardItemProps {
  label: string;
  value: any;
  handleOpenPopupDefect: () => void;
}

const DefectCardStatusItem: FC<DefectCardItemProps> = ({ label, value, handleOpenPopupDefect }) => {
  return (
    <div className={styles.defect__cardItem}>
      <div className={styles.defect__cardLabel}>{label}</div>
      <button 
        className={classNames(styles.defect__cardStatusBtn, 
          value === DEFECT_STATUS_AGREED && styles.defect__cardStatusBtn_green, 
          value === DEFECT_STATUS_CLOSED && styles.defect__cardStatusBtn_green,
          value === DEFECT_STATUS_REMOVED && styles.defect__cardStatusBtn_red, 
          value === DEFECT_STATUS_REJECTED && styles.defect__cardStatusBtn_red,
          value === UNLOADING_MK_SENT && styles.defect__cardStatusBtn_green, 
          value === UNLOADING_MK_ERROR && styles.defect__cardStatusBtn_red,
        )} 
        onClick={handleOpenPopupDefect}
      >
        {value}
      </button>
    </div>
  );
};

export default DefectCardStatusItem;